import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const AreaDistributionChart = ({ data, loading }) => {
  // Debug logging
  console.log("AreaDistributionChart props:", { data, loading });
  console.log("Data length:", data?.length);
  console.log("Sample data item:", data?.[0]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
          <p className="text-sm text-muted-foreground">
            Cargando datos de IPR...
          </p>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            No hay datos de áreas disponibles
          </p>
        </div>
      </div>
    );
  }

  // Colores para el gráfico
  const COLORS = [
    "#3b82f6", // Blue
    "#8b5cf6", // Purple
    "#10b981", // Green
    "#f59e0b", // Orange
    "#ef4444", // Red
  ];

  // Preparar datos para el gráfico de pastel
  const pieData = data.map((item, index) => ({
    name: item.area,
    value: item.cantidad,
    monto: item.monto || 0,
    color: COLORS[index % COLORS.length],
  }));

  console.log("Pie data prepared:", pieData);

  // Calcular total para porcentajes
  const total = data.reduce((sum, item) => sum + item.cantidad, 0);

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const percentage = ((data.value / total) * 100).toFixed(1);
      
      return (
        <div className="bg-white dark:bg-slate-800 p-3 border border-slate-200 dark:border-slate-700 rounded-lg shadow-lg">
          <p className="font-semibold text-slate-900 dark:text-slate-100">
            {data.name}
          </p>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            Cantidad: {data.value} IPRs
          </p>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            Porcentaje: {percentage}%
          </p>
          {data.monto > 0 && (
            <p className="text-sm text-slate-600 dark:text-slate-400">
              Monto: ${data.monto.toLocaleString()}
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-full flex flex-col">
      {/* Debug info */}
      <div className="text-xs text-gray-500 mb-2 p-2 bg-gray-100 rounded">
        Debug: {data.length} áreas, Total: {total} IPRs
      </div>
      
      {/* Gráfico principal */}
      <div className="w-full" style={{ height: '280px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={100}
              paddingAngle={3}
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={entry.color}
                  stroke="#ffffff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
      
      {/* Información adicional */}
      <div className="mt-4 text-center">
        <div className="text-2xl font-bold text-slate-900 dark:text-slate-100">
          {total}
        </div>
        <div className="text-sm text-slate-600 dark:text-slate-400">
          Total de IPRs por área
        </div>
        <div className="mt-2 pt-2 border-t border-slate-200 dark:border-slate-700">
          <div className="flex justify-between text-xs text-slate-500 dark:text-slate-400">
            <span>Distribución organizacional</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaDistributionChart;
